import "./css/newLogin.css";

import { useEffect, useState } from "react";
import media from "../../media";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginThunk } from "../../store/thunks/authThunk";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth = useSelector((state) => state.auth || {});
  const { loading, accessToken, error } = auth;
  const [errors, setErrors] = useState({});
  const [formState, setLoginState] = useState({
    mobile: "",
    password: "",
  });

  useEffect(() => {
    if (accessToken) {
      navigate("/dashBoard", { replace: true });
    }
  }, [accessToken, navigate]);

  const handleLoginEmail = async (e) => {
    e.preventDefault();

    if (formState.mobile && formState.password) {
      setErrors({});

      try {
        await dispatch(
          loginThunk({
            mobile: formState.mobile,
            password: formState.password,
          }),
        ).unwrap();

        // Navigate after successful login
        navigate("/dashBoard");
      } catch (error) {
        console.error(error);
      }
    } else {
      setErrors({
        mobile: formState.mobile ? "" : "Mobile is Mandatory",
        password: formState.password ? "" : "Password is Mandatory",
      });
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Left Side */}

        <div className="login-left">
          <div className="overlay"></div>

          <div className="logo-wrapper text-center">
            <img src={media?.login_logo} alt="logo" className="logo" />
          </div>
        </div>

        {/* Right Side */}

        <div className="login-right">
          <div className="form-container">
            <div className="welcome-text">
              <h1>Welcome Back</h1>

              <p>Sign in to continue to your account</p>
            </div>

            <form className="form login-form mt-7" id="contact" name="contact">
              <div className="mb-3">
                <label className="form-label">Mobile Number</label>

                <input
                  type="text"
                  className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                  placeholder="Enter Mobile Number"
                  value={formState.mobile}
                  onChange={(e) => {
                    setLoginState({
                      ...formState,
                      mobile: e.target.value,
                    });

                    setErrors({
                      ...errors,
                      mobile: "",
                    });
                  }}
                />

                {errors.mobile && (
                  <div className="invalid-feedback d-block">
                    {errors.mobile}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <label className="form-label">Password</label>

                <input
                  type="password"
                  className={`form-control ${errors.password ? "is-invalid" : ""}`}
                  placeholder="Enter Password"
                  value={formState.password}
                  onChange={(e) => {
                    setLoginState({
                      ...formState,
                      password: e.target.value,
                    });

                    setErrors({
                      ...errors,
                      password: "",
                    });
                  }}
                />

                {errors.password && (
                  <div className="invalid-feedback d-block">
                    {errors.password}
                  </div>
                )}
              </div>

              <div className="pb-lg-0 pb-5">
                <button
                  type="button"
                  className="login-btn"
                  onClick={handleLoginEmail}
                  disabled={loading}
                >
                  {loading ? "Signing In..." : "Sign In"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
